export const TICKET_TYPES = {
  COMMON_QUESTION: 'common_question',
  TOUR_SELECTION: 'tour_selection',
  UNKNOWN: 'unknown',
  UPDATING: 'updating',
};

export const CLIENT_LOG_TYPES = {
  CALL: 'call',
  EMAIL: 'email',
  MESSAGE: 'message',
  NOTE: 'note',
  SMS: 'sms',
  MESSAGE_GROUP: 'message_group',
  MANAGER_EMAIL: 'manager_email',
};

export const TICKET_LOG_TYPES = {
  GROUP: 'group',
  SYSTEM: 'system',
  USER: 'user',
  NOTE: 'note',
  TASK: 'task',
  DEBUG: 'debug',
  SYSTEM_AUTO: 'system_auto',
  SYSTEM_VIEW: 'system_view',
  SYSTEM_CHANGE: 'system_change',
  SYSTEM_DISPATCH: 'system_dispatch',
  USER_RATING: 'user_rating',
  TOUR_SELECTION: 'tour_selection',
  USER_CREATION_ACTION: 'user_creation_action',
};

export const LOG_RELATIONS = {
  CLIENT: 'client',
  TICKET: 'ticket',
};
